import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import useAuth from "../../utils/useAuth";
import { resetMemberNotification } from "../../store/organization";
import apiClient from "../../utils/axiosInstance";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import { IoAdd } from "react-icons/io5";
import userPicture from "../../assets/user.png";

function SidebarRenderDMs({ isItemActive, setActiveItemId }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const memberId = queryParams.get('id');
    const { user } = useAuth();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [dms, setDms] = useState([]);
    const { organizationState } = useAppSelector((state) => ({
        organizationState: state.organization.organization,
    }));

    useEffect(() => {
        if (user && location.pathname==="/dm") {
            const dms = organizationState[0]?.members?.filter((member) => member.userId !== user?.userId && member.isAccepted === true);
            setDms(dms);
            if (dms?.length > 0 && !memberId) {
                const member = dms[0];
                setActiveItemId(member.userId);
                navigate(`/dm?id=${member.userId}`);
            }
        }
    }, [location?.state, user]);

    const handleItemClick = (itemId) => {
        setActiveItemId(itemId);
    };

    const resetOrgMemberNotification = async (memberId) => {
        try {
            await apiClient().put(`/reset-notification/${memberId}`);
            dispatch(
                resetMemberNotification({ memberId: memberId, notification: 0 })
            );
        } catch (error) {
            console.error("Error resetting notification:", error);
        }
    };

    return (
        <ul className="space-y-2 px-3 py-1 ">
            <li>
                <div className="flex items-center justify-between py-5 border-b-2">
                    <p className="text-xl font-bold">Direct Messages</p>
                </div>
            </li>
            {dms?.map((item, index) => { 
                
                return (
                <li
                    key={index}
                    className={`text-sm flex items-center overflow-y-auto p-1 rounded-lg transition-colors duration-200 hover:bg-gray-200`}
                    style={{
                        background: isItemActive(item.userId) ? organizationState[0]?.secondaryColor : "",
                    }}
                >
                    <div className="relative mr-2">
                        <img src={item.userPictureUrl || userPicture} alt="Profile" className="w-6 h-6 object-cover rounded-full" />
                        <span
                            className={`absolute bottom-0 right-0 w-2 h-2 rounded-full ${item.user_status === "online" ? "bg-green-500" : "bg-gray-500"
                                }`}
                        ></span>
                    </div>
                    <Link
                        to={`/dm?id=${item.userId}`}
                        style={{
                            color: isItemActive(item.userId) ? "white" : "black"  
                          }}
                        onClick={(e) => {
                            handleItemClick(item.userId);
                            if (item.notification > 0) {
                                e.preventDefault();
                                resetOrgMemberNotification(item.userId).then(() => {
                                    navigate(`/dm?id=${item.userId}`);
                                });
                            }
                        }}
                        className={`truncate w-40 flex-grow text-landing capitalize  font-normal flex items-center justify-between`}
                    >
                        <span >{item.name}</span>
                        {item.notification > 0 && (
                            <span className="bg-red-500 text-white text-xs font-bold w-5 h-5 p-[1.5px] rounded-full ml-2 text-center">
                                {item.notification}
                            </span>
                        )}
                    </Link>
                </li>
            )})}
            {dms?.length > 10 && <button
                className=" font-normal text-center ml-2 border-b-2 "
                style={{ color: `${organizationState[0]?.primaryColor}`, borderColor: `${organizationState[0]?.primaryColor}` }}
                onClick={() => navigate("/dms")}
            >
                View All
            </button>
            }
            <div className="flex items-center gap-2 py-2 rounded hover:bg-slate-200 cursor-pointer" onClick={() => { navigate(`/account`, { state: { tab: "Members" } }) }}>
                <div className="flex items-center justify-center p-1 ml-1 mt- rounded-md" style={{backgroundColor:"#e5e7eb"}}><IoAdd/></div>
                <button className="text-center text-sm" >
                  Create new DM
                </button>
              </div>
        </ul >
    );
}

export default SidebarRenderDMs;
